import { useMemo } from 'react';
import { useBlockAppearanceStylesContext } from '../../context/BlockAppearanceStylesProvider';
import type { AppearanceStyles, StyleResult } from './types';

const useBlockAppearanceStyles = ({
  appearanceStyles,
}: {
  appearanceStyles: AppearanceStyles;
}): StyleResult => {
  const { processStyles } = useBlockAppearanceStylesContext();

  return useMemo(() => {
    return processStyles(appearanceStyles);
  }, [processStyles, appearanceStyles]);
};

export default useBlockAppearanceStyles;
